import React, { useState } from "react";
import { message } from "antd";
import validator from "validator";
import customerServices from "../../services/CustomerService";

const ContactUs = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false); // State for thank you note

  const validateEmail = (email) => validator.isEmail(email);

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(
      value && !validateEmail(value) ? "Please enter a valid email address" : ""
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setEmailError("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await customerServices.PostEmailForNewsletter(email); // Pass email directly
      console.log("Response from service:", response);
      if (response) {
        // message.success("Successfully subscribed to the newsletter!");
        setEmail("");
        setEmailError("");
        setShowThankYou(true);
        //setTimeout(() => setShowThankYou(false), 8000); // Hide after 5 seconds
      }
    } catch (error) {
      // message.error("An error occurred. Please try again later.");
      console.log("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-5 bg-dark text-white">
      <div className="container">
        <div className="d-md-flex flex-column flex-md-row justify-content-between align-items-start">
          <div className="text-center text-md-start">
            <h4 className="fw-bold" id="main-font">
              Contact Us
            </h4>
            <a
              className="mb-1 text-white d-block"
              href="mailto:jaime@mikrobank.com"
            >
              info@proslay.com
            </a>
            <p className="mb-1">(973) 396-6186</p>
            <p className="mb-1">PO Box 521</p>
            <p>Livingston NJ 07039</p>
          </div>
          <div className="mt-4 mt-md-0 text-center">
            <h4 className="fw-bold mb-1" id="main-font">
              Subscribe to Our Newsletter
            </h4>
            <p className="mb-3">Stay updated with our latest news!</p>
            {showThankYou ? (
              <div>
                {" "}
                <h4 className="fw-bold mb-1" id="main-font" role="alert">
                  Thank you for subscribing to our newsletter!
                </h4>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                className="d-flex justify-content-center"
              >
                <div className="position-relative">
                  <input
                    type="email"
                    autoComplete="email"
                    className={`form-control me-2 ${
                      emailError ? "is-invalid" : ""
                    }`}
                    placeholder="Enter your email"
                    style={{ maxWidth: "250px" }}
                    value={email}
                    onChange={handleEmailChange}
                    aria-describedby="emailError"
                  />
                  <div
                    id="emailError"
                    className="invalid-feedback"
                    style={{
                      textAlign: "left",
                      position: "absolute",
                      top: "90%",
                      left: 0,
                      marginTop: "5px",
                    }}
                  >
                    {emailError}
                  </div>
                </div>
                <button
                  className="btn btn-light btn-sm mx-1"
                  type="submit"
                  id="main-font"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Subscribing..." : "Subscribe"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
